export { Ribbon, RibbonSize } from './Ribbon';
